/**
 * APIs que dependências usam sem checar se existem.
 *
 * O build do Vite rebaixa a SINTAXE para navegadores antigos (target padrão:
 * Chrome 87, Safari 14), mas não acrescenta APIs que faltam. Quando uma lib
 * chama uma função ausente durante o render, o ErrorBoundary da raiz derruba a
 * aplicação inteira.
 *
 * Importado antes de tudo em index.tsx.
 */

// Chrome < 93 (Chromebooks sem atualização ficam presos no 91) e Safari < 15.4.
// O react-markdown 10 chama Object.hasOwn a cada render: sem isto, qualquer
// markdown — inclusive o modal obrigatório dos Termos — vira tela de erro.
if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: (objeto: object, chave: PropertyKey) =>
      Object.prototype.hasOwnProperty.call(objeto, chave),
    configurable: true,
    writable: true,
  });
}

export {};
